import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WorkshopJobEventBase } from '../../../models/workshop-job-event';
import { ConfigService } from '../../../shared/services/config.service';
import { map } from 'rxjs/operators';
import { WORKSHOP } from '../../../../testIds';
import { WorkshopJobEventLabelPipe } from '../workshop-job-event-label.pipe';
import { MomentModule } from 'ngx-moment';
import { HlCurrencyPipe } from '../../../shared/pipes/hl-currency.pipe';
import { UserIdToNamePipe } from '../../../shared/pipes/user-id-to-name.pipe';
import { KeyValuePairComponent } from '../../../shared/general/key-value-pair/key-value-pair.component';
import { NgSwitch, NgSwitchCase, NgIf, AsyncPipe } from '@angular/common';
import { TestIdDirective } from '../../../shared/directives/test-id.directive';
import { MatCard, MatCardContent } from '@angular/material/card';

@Component({
    selector: 'app-workshop-job-event',
    templateUrl: './workshop-job-event.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatCard, TestIdDirective, MatCardContent, NgSwitch, NgSwitchCase, KeyValuePairComponent, NgIf, AsyncPipe, UserIdToNamePipe, HlCurrencyPipe, MomentModule, WorkshopJobEventLabelPipe]
})
export class WorkshopJobEventComponent {
  testIds = WORKSHOP;
  @Input() event: WorkshopJobEventBase<any>;

  currency = this.configService.userConfig.pipe(
    map((config) => config?.currency ?? 'GBP')
  );

  constructor(private configService: ConfigService) {}
}
